import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/folder.svg
 */
const IconFolder: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2H10L8 4zm1.586 3l-2-2H4a1 1 0 00-1 1v12a1 1 0 001 1h16a1 1 0 001-1V8a1 1 0 00-1-1H9.586z"
      fill="currentColor"
    />
  </svg>
);

export default IconFolder;
